import { useEffect, useState } from "react";
import { api, type Catalogue } from "../api";
import { Footer, PublicHeader, link } from "../App";
import { sellingLive, sizeLabel } from "../billing";
import { errorText, useT } from "../i18n";
import { Chooser } from "./Billing";

/**
 * The public plans page (PLAN.md 4.24, 4.26): what the payment provider sells, read-only. Buying
 * happens on Billing, after sign-in. Until selling is live the page describes the free pilot and
 * its plans instead of the provider's test prices.
 */
export function Pricing() {
  const t = useT();
  const [catalogue, setCatalogue] = useState<Catalogue | null>(null);
  const [error, setError] = useState<string | null>(null);
  useEffect(() => { api.catalogue().then(setCatalogue, (err) => setError(errorText(err))); }, []);
  const selling = catalogue ? sellingLive(catalogue) : null;
  return (
    <>
      <PublicHeader />
      <main className="pricing-page">
        <div className="page-head">
          <h1>{t.billing.pricing.title}</h1>
          {selling !== null && <p className="muted">{selling ? t.billing.pricing.lead : t.billing.pricing.pilotLead}</p>}
        </div>
        {error && <p className="error" role="alert">{error}</p>}
        {catalogue && selling === false && <PilotPlans catalogue={catalogue} />}
        <p className="small">{t.billing.pricing.stampDef}</p>
        {catalogue && selling && <Chooser catalogue={catalogue} view={null} />}
        <p className="small"><a href="/billing" onClick={link("/billing")}>{t.billing.pricing.signIn}</a></p>
      </main>
      <Footer />
    </>
  );
}

function PilotPlans({ catalogue }: { catalogue: Catalogue }) {
  const t = useT();
  return (
    <section className="card">
      <h2>{t.billing.pricing.pilotTitle}</h2>
      <p>{t.billing.pricing.pilotPlans}</p>
      <div className="offers">
        {(["legacy", "free"] as const).map((id) => {
          const p = catalogue.plans.find((plan) => plan.id === id);
          if (!p) return null;
          return (
            <article key={id} className="offer">
              <h3>{t.billing[id].name}</h3>
              <p className="small">{t.billing.planDetail(p.monthly_units, sizeLabel(p.base_storage_bytes), sizeLabel(p.attachment_bytes))}</p>
              <p className="small muted">{t.billing[id].text}</p>
            </article>
          );
        })}
      </div>
      <p className="small">{t.billing.pricing.pilotChanges}</p>
    </section>
  );
}
